// --
import React from 'react';
import classNames from 'classnames';
import AbstractReactComponent from "../AbstractReactComponent";

import "./DetailValue.scss";

/**
 * Komponenta pro label a hodnotu pro použití na detailech.
 * Pokud je obsahem řetězec (text) a ten obsahuje \n, jsou pro render použity <span> oddělené pomocí <br/>.
 */
class DetailValue extends AbstractReactComponent {
    static propTypes = {
        label: React.PropTypes.oneOfType([React.PropTypes.node]), // label hodnoty
        emptyValue: React.PropTypes.string,  // co zobrazovat když hodnota je prázdná, implicitně "-", pokud je null a má práznou hodnotu, vůbec se nerenderuje dd tag, pokud je např. "", dd se renderuje
        textOverflow: React.PropTypes.bool,  // pokud je true, je na hodnotu použit styl pro oříznutí velkých textů na tři tečky
        valueTitle: React.PropTypes.string,  // title na value
        horizontal: React.PropTypes.bool,   // pokud je true, je zobrazováno horizontálně, standardn2 false
        title: React.PropTypes.string,  // title na vše
    };

    static defaultProps = {
        emptyValue: "-"
    };

    /**
     * Má nějaké potomky, které se budou renderovat?
     * @return {boolean} true, pokud má nějaké potomky, které se budou renderovat
     */
    hasChildren = () => {
        const {children} = this.props;

        if (typeof children === "number") {
            return true;
        }

        if (children) {
            if (Array.isArray(children)) {
                let hasNotNull = false;
                for (let a=0; a<children.length; a++) {
                    if (typeof children[a] === "number" || children[a]) {
                        hasNotNull = true;
                        break;
                    }
                }
                return hasNotNull;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    render() {
        const {title, horizontal, valueTitle, textOverflow, emptyValue, label, children, className} = this.props;

        const wrapperClassNames = classNames(
            className, {
                "text-overflow": textOverflow,
                "detail-value-horizontal": horizontal
            }
        );
        let content;
        if (this.hasChildren()) {
            if (typeof children === "string") {
                content = children.split('\n').map((item, key) => {
                    return <span key={key}>{item}<br/></span>
                });
            } else {
                content = children;
            }
        } else {
            content = emptyValue;
        }

        return <dl className={wrapperClassNames} title={title}>
            {label && <dt>{label}</dt>}
            {content !== null && <dd title={valueTitle}>{content}</dd>}
        </dl>
    }
}

export default DetailValue;
